import request from '@/utils/request';

export interface TicketTypeFieldConfig {
  field_type: number;
  requirement: number;
  sequence_no: number;
}

export interface RaiseTicketTypeItem {
  ticket_type_id?: string;
  ticket_type_name?: string;
  ticket_type?: string;
  process?: number;
  stage?: number;
}

export interface SearchRaiseTicketTypeRequest {
  process: number;
  stage: number;
}

export interface RaiseTicketTypeConfig {
  ticket_type_id?: string;
  ticket_type_name?: string;
  process?: number;
  stage?: number;
  require_supervisor_verification?: number;
  supervisor_takeover_required?: number;
  field_configs?: TicketTypeFieldConfig[];
}

export interface GetRaiseTicketTypeConfigRequest {
  process: number;
  stage: number;
  ticket_type_id: string;
}

export interface CreateGenericTicketRequest {
  ticket_type_id: string;
  process: number;
  stage: number;
  location_id?: string;
  station_id?: string;
  dock_no?: string;
  device_id?: string;
  sku_id?: string;
  text_remark?: string;
}

export interface CreateGenericTicketResponse {
  ticket_id?: string;
  assignee?: string;
  ref_task_id?: string;
  supervisor_assignees?: string[];
}

export interface CheckSupervisorPasswordRequest {
  ticket_id: string;
  password: string;
}

export const searchRaiseTicketType = async (
  params: SearchRaiseTicketTypeRequest
) => {
  const res = await request.get(
    /* PermissionKey: ALL */
    '/api/v2/apps/access/inventory/ticket/search_raise_ticket_type',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};

export const getRaiseTicketTypeConfig = async (
  params: GetRaiseTicketTypeConfigRequest
) => {
  const res = await request.get(
    /* PermissionKey: ALL */
    '/api/v2/apps/access/inventory/ticket/get_raise_ticket_type_config',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};

export const createGenericTicket = async (
  params: CreateGenericTicketRequest
) => {
  const res = await request.post(
    /* PermissionKey: ALL */
    '/api/v2/apps/access/inventory/ticket/create_generic_ticket',
    {
      ...params,
    }
  );
  return res;
};

export const checkSupervisorPassword = async (
  params: CheckSupervisorPasswordRequest
) => {
  const res = await request.post(
    /* PermissionKey: ALL */
    '/api/v2/apps/access/inventory/ticket/check_supervisor_password',
    {
      ...params,
    }
  );
  return res;
};
